import { gql } from '@apollo/client';

export const GET_WORKSPACE = gql`
  query GetWorkspace($id: ID!) {
    workspace: getWorkspace(id: $id) {
      id
      name
      description
      default
      programmes {
        id
        name
      }
      interventions {
        id
        name
      }
      datasetsLinks {
        id
        description
        type
      }
    }
  }
`;
